import { useDispatch } from "react-redux";
import userActions from "../actions/User";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import HeaderLogin from "../components/HeaderLogin";
import Footer from "../components/Footer";
import { ISSUER } from "../creds";
import { Modal } from "react-bootstrap";
import loginImage from '../assets/homepage-capitol-4.jpg';

const roleMapping = {
  "testuser1@gmail.com": "OAG",
  "testuser2@gmail.com": "CSL",
  "testuser3@gmail.com": "CPA",
};

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [securitypopup, setSecuritypopup] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const clickCreateAccount = () => {
    setSecuritypopup(true);
  };

  const clickLogin = (e) => {
    e.preventDefault();
    navigate("/");
  };

  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
    setError("");
  };

  return (
    <div className="login-container bg-light">
      <HeaderLogin />

      <div className="container py-5">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-4 mb-4 mb-lg-0 text-center">
            <img src={loginImage} alt="Capitol" className="img-fluid rounded" />
          </div>
          <div className="col-lg-6 text-center text-lg-start">
            <h2 className="display-5 fw-bold">
              Welcome to the Texas Transcript Repository System
            </h2>
            <p className="lead mt-3">
              Securely access and manage your transcripts through the official Texas state portal.
            </p>
            <div className="mt-4 d-flex flex-column flex-md-row justify-content-center align-items-center gap-3">
              <button className="btn btn-dark btn-lg" onClick={clickLogin}>
                Existing User
              </button>
              <button className="btn btn-dark btn-lg" onClick={clickCreateAccount}>
                New User
              </button>
            </div>
          </div>
        </div>

        <div className="row mt-5 justify-content-center">
          <div className="col-lg-10">
            <div className="alert alert-info fs-5 fw-semibold text-center">
              We recommend that you use the latest version of <strong>Chrome</strong>, Microsoft <strong>Edge</strong>, or <strong>Safari</strong> for the <strong>best user experience</strong>.
            </div>

            <div className="alert alert-danger border-start border-5 border-danger-subtle fs-6">
              <strong className="text-danger">WARNING - RESTRICTED GOVERNMENT SYSTEM.</strong><br />
              This system is restricted to authorized users only. Unauthorized access, use, or misuse or modification of this system, the data contained herein, or in transit to/from this system, may constitute a violation of federal, state and local laws and subject individual(s) to criminal and/or civil prosecution and penalties. This system and associated usage is subject to monitoring and security testing by authorized personnel. There is no expectation of privacy except as otherwise provided by applicable privacy laws.
            </div>
          </div>
        </div>
      </div>

      <Footer isLoggedIn="False" />

      {/* Modal for Security Notice */}
      <Modal show={securitypopup} centered>
        <Modal.Header>
          <Modal.Title>Important Notice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          By selecting Continue you are agreeing not to submit or upload confidential information including, but not limited to, Social Security numbers, bank account numbers or payment details.
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={() => setSecuritypopup(false)}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              navigate("/create-account");
              setSecuritypopup(false);
            }}
          >
            Continue
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Login;
